export type PDFWorkRequest = {
    originalWorkRequest: any
    serviceCode?: string
    type: PDFWorkRequestType
    workToBePerformed?: string
    specialInstructions?: string
    tasks?: PDFWorkRequestTask[]
    estimatedLaborHours?: number
    estimatedLaborCost?: number
    estimatedPartsCost?: number
    estimatedTotalCost?: number
    // Action Item 6764: typed fields consumed by the form-style Work Order PDFs
    // (WorkOrderFormPDF). Optional so the legacy templates keep working unchanged.
    id?: number | null
    name?: string
    status?: PDFWorkRequestStatus
    stepLabel?: string | null
    workPerformedBy?: string[]
    actualLaborHours?: number | null
    actualLaborCost?: number | null
    actualPartsCost?: number | null
    actualOtherCost?: number | null
    notes?: string
    dueDate?: string | null
    dueHourMeter?: number | null
    dueOdometer?: number | null
    attachmentNames?: string[]
}

export type PDFWorkRequestTask = {
    measurement?: string
    name: string
    description?: string
    status?: string
}

export enum PDFWorkRequestType {
    Preventative = "preventative",
    Inspection = "inspection",
    Service = "service",
}

export enum PDFWorkRequestStatus {
    ToDo = "toDo",
    WorkNotPerformed = "workNotPerformed",
    Done = "done",
}
